module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_chapel_2-abc3ab53c4b88d1f9359fb7f3b69b27f.jpg";